module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jobSingle-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.solutionlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "job-single-content section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "single-content1"
  }, [(_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.solutionlist.position2[0].title))]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.solutionlist.position2[0].brief))])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 最新发布时间:" + _vm._s(_vm.solutionlist.position2[0].created_at))])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "forth-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("联系我吧")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-content4 single-job py-4"
    }, [_c('h4', {
      staticClass: "mobile_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('ul', {
      staticClass: "mobile_ul"
    }, [_c('li', {
      staticClass: "mb-2",
      staticStyle: {
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])])
  })], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-826239f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobSingle.vue
// module id = 297
// module chunks = 1